import React from "react";
import { useSelector } from "react-redux";
import { formValueSelector } from "redux-form";

import { CustomInput } from "components";
import { FieldWithReadOnlyMode } from "components/formFields";
import { FormColumn, FormRow } from "components/layout";
import {
	exactNumberOfDigits9,
	matchesCityRegex,
	maxLength30,
	minLength2,
	regExpOneSpace,
	required,
	trimMidSentenceNormalizer,
	trimNormalizer,
} from "validators";
import { zipField } from "validators/userValidators";
import { onlyTwoUpperCaseLetters, maxLength2 } from "validators/validation";

type CheckFieldsProps = {
	loading: boolean;
	formName: string;
	isEditable: boolean;
};

export const CheckFields = ({
	loading,
	formName,
	isEditable,
}: CheckFieldsProps) => {
	const selector = formValueSelector(formName);
	const formValue = useSelector(state => selector(state, "payment_info"));

	const validateState = [required, minLength2, maxLength2];
	const validateCity = [
		required,
		matchesCityRegex,
		regExpOneSpace,
		minLength2,
		maxLength30,
	];
	return (
		<>
			<FormRow>
				<FormColumn>
					<FieldWithReadOnlyMode
						label="Payee Name"
						component={CustomInput}
						smLabel={5}
						smSelect={7}
						type="text"
						validate={[required]}
						name="payee_name"
						blurLoading={loading}
						normalizeOnBlur={trimNormalizer}
						readOnlyProps={{
							isEditable,
							value: formValue?.check?.payee_name,
						}}
					/>
				</FormColumn>
				<FormColumn>
					<FieldWithReadOnlyMode
						label="House Number &amp; Street"
						component={CustomInput}
						smLabel={5}
						smSelect={7}
						type="text"
						validate={[required]}
						name="address.address_line1"
						blurLoading={loading}
						normalizeOnBlur={trimNormalizer}
						readOnlyProps={{
							isEditable,
							value: formValue?.check?.address?.address_line1,
						}}
					/>
				</FormColumn>
			</FormRow>
			<FormRow>
				<FormColumn>
					<FieldWithReadOnlyMode
						label="City"
						component={CustomInput}
						smLabel={5}
						smSelect={7}
						type="text"
						validate={validateCity}
						normalize={trimMidSentenceNormalizer}
						name="address.city"
						blurLoading={loading}
						normalizeOnBlur={trimNormalizer}
						readOnlyProps={{
							isEditable,
							value: formValue?.check?.address?.city,
						}}
					/>
				</FormColumn>
				<FormColumn>
					<FieldWithReadOnlyMode
						label="Zip Code"
						component={CustomInput}
						smLabel={5}
						smSelect={7}
						type="text"
						validate={[required, zipField]}
						normalize={exactNumberOfDigits9}
						name="address.postal_code"
						blurLoading={loading}
						readOnlyProps={{
							isEditable,
							value: formValue?.check?.address?.postal_code,
						}}
					/>
				</FormColumn>
			</FormRow>
			<FormRow>
				<FormColumn>
					<FieldWithReadOnlyMode
						label="State"
						component={CustomInput}
						smLabel={5}
						smSelect={7}
						type="text"
						normalize={onlyTwoUpperCaseLetters}
						validate={validateState}
						name="address.region_code"
						blurLoading={loading}
						readOnlyProps={{
							isEditable,
							value: formValue?.check?.address?.region_code,
						}}
					/>
				</FormColumn>
			</FormRow>
		</>
	);
};
